import React, {useEffect, useState} from 'react';
import {Button, DropdownMenu, DropdownToggle, Label, UncontrolledDropdown} from "reactstrap";

const WMSProcessingFilter = ({color = 'white', onChange, selected}) => {
    const [labelCreated, setLabelCreated] = useState(false)
    const [labelNotCreated, setLabelNotCreated] = useState(false)


    useEffect(()=>{

        let testLabelCreated = selected.filter(s => ("wms_processed" === s.value))
        setLabelCreated(testLabelCreated?.length > 0)

        let testLabelNotCreated = selected.filter(s => ("wms_processing" === s.value))
        setLabelNotCreated(testLabelNotCreated?.length > 0)




    }, [selected, onChange])
    return (
        <UncontrolledDropdown size={"sm"}>
            <DropdownToggle
                color={color}
                className={(color === 'white') ? "text-primary" : "p-10px"}
                caret>
                WMS Processing
            </DropdownToggle>
            <DropdownMenu className="more-filters-dropdown-menu" right>
                <ul className={"pl-2 overflow-auto"} style={{maxHeight: "300px"}}>

                    <li className={"list-unstyled mt-2"}>
                        <Label className={"text-sm"}>
                            <input type="checkbox"
                                id={"wms_processed"}
                                className={"checkbox_" + 'wms_processing'}
                                data-label={"WMS Processed"}
                                value={"processed"}
                                onChange={(e)=> onChange(e, "wms_processing")}
                                defaultChecked={ labelCreated }
                            /> WMS Processed
                        </Label>
                    </li>
                    <li className={"list-unstyled "}>
                        <Label className={"text-sm"}>
                            <input type="checkbox"
                                id={"wms_processing"}
                                className={"checkbox_" + 'wms_processing'}
                                value={"processing"}
                                onChange={(e)=> onChange(e, "wms_processing")}
                                data-label={"WMS Processing"}
                                defaultChecked={ labelNotCreated }
                            /> WMS Processing
                        </Label>
                    </li>

                </ul>
            </DropdownMenu>
        </UncontrolledDropdown>
    );
}

export default WMSProcessingFilter;